import { Alert, Button, Container } from 'react-bootstrap';
import { useRouteError } from 'react-router-dom';

/** What a render crash shows in place of the app. The menu is gone with it, so the way on is here (SSD-7815). */
const AppCrashScreen = () => {
  const error = useRouteError();
  return (
    <Container className="py-5">
      <Alert variant="danger">
        <Alert.Heading>This page hit an error</Alert.Heading>
        <p>{error instanceof Error ? error.message : 'Something went wrong.'}</p>
        <Button variant="outline-danger" size="sm" onClick={() => window.location.reload()}>
          Reload
        </Button>{' '}
        <Button variant="outline-secondary" size="sm" href="/">
          Home
        </Button>
      </Alert>
    </Container>
  );
};

export default AppCrashScreen;
